import { Component, OnInit } from '@angular/core';
import{UserServices} from '../services/userservices.service'
@Component({
  selector: 'app-patient',
  templateUrl: './PatientList.component.html',
  styleUrls: ['./PatientList.component.css']
})
export class PatientListComponent implements OnInit {
  reports: any[];
    //reports:Observable<any>;
  constructor(private userServices:UserServices) { }

  ngOnInit() {
    this.getPatient();
  }

  sendOtp(){
    console.log("i have been clicked")
  }
  getPatient(){
    this.userServices.getPatientsList().subscribe(
      (employeeData) => {
          if (employeeData == null) {             
          }
          else {
              console.log('employeeData.response.patientList')
              console.log(employeeData.response.patientList)
              // employeeData.response.patientList.sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
              // employeeData.response.patientList.sort((a, b) => {
              //     if (Date.parse(a.createdDate) < Date.parse(b.createdDate)) return -1;
              //     else if (Date.parse(a.createdDate) > Date.parse(b.createdDate)) return 1;
              //     else return 0;
              // });
              this.reports = employeeData.response.patientList
              console.log(this.reports)
          }
      },
      (error) => {          
          console.log(error);
      }
  );;
  }

}
